import { render, staticRenderFns } from "./addKPI2.vue?vue&type=template&id=2e52789b&"
import script from "./addKPI2.vue?vue&type=script&lang=js&"
export * from "./addKPI2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports